import React, { useEffect } from 'react';

// styling
import styled from 'styled-components';

// constants
import { Timeline30MinLayoutColumnWidth } from '../../../../utils/timeline-constants';

const TimelineColumnDiv = styled.div`
  border: 1px solid lightgrey;
  min-width: ${Timeline30MinLayoutColumnWidth};
  min-height: 75px;
  display: flex;
  position: relative;
`;

const IntervalLine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: lightgrey;
`;

const TimelineThirtyMinColumnContainer = (props) => {

    const intervals = Array.from({ length: 6 }); // 6 intervals for 5-minute blocks in 30 minutes

    const handleIntervalClick = (e) => {

        const boundingRect = e.currentTarget.getBoundingClientRect();
        const clickPositionX = e.clientX - boundingRect.left; // X position relative to the div
        const intervalWidth = boundingRect.width / intervals.length; // Width of each interval
        const clickedInterval = Math.floor(clickPositionX / intervalWidth); // Calculate which interval

        props.onClick(clickedInterval);
    };


    return (
        <TimelineColumnDiv
            style={{
                position: 'relative',
                width: "100%",
                backgroundColor: props.backgroundColor,
                borderColor: props.borderColor,
            }}
            onClick={handleIntervalClick}
        >
            {props.children}
        </TimelineColumnDiv>
    );
};

export default TimelineThirtyMinColumnContainer;